export const EDITOR = {
    root: "editor-root",
    splitView: "editor-split-view",
    mobileCarousel: "editor-mobile-carousel",
    sectionDots: "editor-section-dots",
    fabPreview: "fab-preview-toggle",
    closePreview: "fab-close-preview",
    templateClassic: "template-pick-classic-elegant",
    templateMinimal: "template-pick-minimal-modern",
    fieldPrimary: "field-primary-name",
    fieldSecondary: "field-secondary-name",
    fieldDate: "field-wedding-date",
    fieldTagline: "field-tagline",
    fieldMessage: "field-message",
    fieldCeremonyName: "field-ceremony-name",
    fieldCeremonyAddress: "field-ceremony-address",
    fieldCeremonyTime: "field-ceremony-time",
    fieldCeremonyMap: "field-ceremony-map",
    fieldPartyName: "field-party-name",
    fieldPartyAddress: "field-party-address",
    fieldPartyTime: "field-party-time",
    fieldPartyMap: "field-party-map",
    fieldCover: "field-cover-image",
    fieldCoverUpload: "field-cover-upload",
    aiImproveBtn: "btn-ai-improve-message",
    nextSection: "btn-next-section",
    prevSection: "btn-prev-section",
    publishButton: "btn-publish-wedding",
    draftButton: "btn-save-draft",
    validationToast: "validation-toast",
};

export const DRAFT = {
    modal: "draft-modal",
    close: "draft-modal-close",
    emailField: "draft-email-field",
    submit: "draft-submit",
    successSheet: "draft-success-sheet",
    successCopy: "draft-success-copy",
    successLink: "draft-success-link",
};

export const PRICING = {
    sheet: "pricing-sheet",
    close: "pricing-close",
    checkoutButton: "checkout-pay-btn",
    // Legacy — kept for backwards-compat with older tests. Not used by the
    // single-tier UI anymore.
    cardBasic: "plan-card-basic",
    cardPremium: "plan-card-premium",
    cardUltra: "plan-card-ultra",
    pickBasic: "plan-pick-basic",
    pickPremium: "plan-pick-premium",
    pickUltra: "plan-pick-ultra",
    successSheet: "publish-success-sheet",
    successCopy: "publish-success-copy",
    successOpen: "publish-success-open",
};

export const CHECKOUT_SUCCESS = {
    root: "checkout-success-root",
    polling: "checkout-success-polling",
    error: "checkout-success-error",
    publicUrl: "checkout-success-public-url",
    copyUrl: "checkout-success-copy-url",
    openUrl: "checkout-success-open-url",
    weddingCode: "checkout-success-wedding-code",
    copyCode: "checkout-success-copy-code",
    goToAdmin: "checkout-success-go-admin",
};

export const LANDING = {
    root: "landing-root",
    cta: "landing-cta",
    templatePreviewClassic: "landing-template-classic",
    templatePreviewMinimal: "landing-template-minimal",
};

export const PREVIEW = {
    root: "wedding-preview",
    menuBtn: "wedding-menu-btn",
    menuSheet: "wedding-menu-sheet",
    menuClose: "wedding-menu-close",
    countdown: "wedding-countdown",
    countdownDays: "countdown-days",
    countdownHours: "countdown-hours",
    countdownMinutes: "countdown-minutes",
    countdownSeconds: "countdown-seconds",
    ceremonyMapBtn: "ceremony-map-btn",
    partyMapBtn: "party-map-btn",
};
